exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UsersAnalyticsHome_paper__2HcQO {\n  margin-bottom: 24px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  padding: 15px; }\n\n.UsersAnalyticsHome_filterPaper__3fbCU {\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin-left: auto; }\n", ""]);

// exports
exports.locals = {
	"paper": "UsersAnalyticsHome_paper__2HcQO",
	"filterPaper": "UsersAnalyticsHome_filterPaper__3fbCU"
};